export enum EContext {
  Document = 'document',
  DocumentView = 'documentView',
  Resource = 'resource',
}
